export const MEDIA_BREAK_POINTS = {
  SMALL_MOBILE: 400,
  MOBILE: 992,
  WEB: 1280,
  TABLET: 1540,
};

export const STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILURE: 'failure',
};

export const US_DATE_FORMAT = 'MM/DD/YYYY';
export const GLOBAL_DATE_FORMAT = 'MMM DD, YYYY';

export const USER_LEVELS = {
  COMPANY: 'company',
};

export const USER_DATA_VALIDATION_FIELD = 'hash';

export const COMMUNITY_RELATION_TYPE = {
  COMMUNITY: 'community',
  COMPETITOR: 'competitor',
};

export const COMMUNITY_CONTRACT_TYPE = {
  RENTAL: 1,
  TYPE_A: 10,
  TYPE_B: 11,
  TYPE_C: 12,
};

export const CONTRACT_SLUG_PREFIX = 'CT';
export const RENTAL_CONTRACT_SLUG = `${CONTRACT_SLUG_PREFIX}-${COMMUNITY_CONTRACT_TYPE.RENTAL}-0`;

export const COMMUNITY_CCRC_CONTRACT_TYPES = [
  COMMUNITY_CONTRACT_TYPE.TYPE_A,
  COMMUNITY_CONTRACT_TYPE.TYPE_B,
  COMMUNITY_CONTRACT_TYPE.TYPE_C,
];

export const CONTRACT_DISPLAY_TYPES = {
  MY_CONTRACTS: 1,
  EVERYONES_CONTRACTS: 2,
};

export const COMMUNITY_CONTRACT_SELECTION_TYPE = {
  APPROXIMATE: 1,
  EXACT: 2,
};

export const ACTOR_TYPE = {
  PRIMARY_USER: 'primary_user',
  USER: 'user',
  COMPANY: 'company',
  COMMUNITY: 'community',
  COMPETITOR: 'competitor',
  HOLDING: 'holding',
};

export const USER_GROUPS = {
  INCENTIVES_CORPORATE: 'Incentives Corporate',
  INCENTIVES_SALESPERSON: 'Incentives Salesperson',
  MYSTERY_SHOP_ADMIN: 'Mystery Shop Admin',
  MYSTERY_SHOP_SHOPPER: 'Mystery Shop Shopper',
  VENDOR_SHOP_ADMIN: 'Vendor Shop Admin',
};

export const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([^<>()[\]\\.,;:\s@"]+\.)+[^<>()[\]\\.,;:\s@"]{2,})$/i;

export const SORT_ORDER = {
  ASCEND: 'ascend',
  DESCEND: 'descend',
};

export const FILE_SOURCE = {
  MEDIA: 1,
  INCENTIVE: 2,
};

export const APARTMENT_TYPE = {
  OVERALL: 1,
};

export const DEVICE_SIZES = {
  MOBILE: 450,
  TABLET: 768,
  DESKTOP: 1024,
};

// OpenAI reads only png, jpeg, gif and webp, and one unreadable image fails the whole AI
// Competitive Intelligence request, so the category silently scores 0 (PA-3139). jfif is JPEG data
// under a different extension.
export const SUPPORTED_IMAGE_TYPES = {
  EXTENSIONS: ['jpg', 'jpeg', 'jfif', 'png', 'gif', 'webp'],
  MIME_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
};

export const FILE_TYPE_EXTENSIONS = {
  IMAGES: ['jpg', 'jpeg', 'png', 'gif', 'svg', 'webp'],
};
